import React, { useRef, useState } from 'react';
import './Contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { BsLinkedin } from 'react-icons/bs';
import { FiSend } from 'react-icons/fi';
import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('idle');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');
    emailjs
      .sendForm('service_py9mqft', 'template_3hknl8f', form.current, '0Ba-zcJd7iR5uaxC0')
      .then(
        () => {
          setStatus('sent');
          e.target.reset();
          setTimeout(() => setStatus('idle'), 4000);
        },
        () => setStatus('error')
      );
  };

  return (
    <section id="contact">
      <h5>Contact</h5>
      <h2>Get in touch</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <a href='mailto:felipealbertosantos@outlook.com'>Send a message →</a>
          </article>

          <article className="contact__option">
            <BsLinkedin className='contact__option-icon' />
            <h4>LinkedIn</h4>
            <a href='https://www.linkedin.com/in/felipe-alberto-8b01a2268/' target='_blank' rel='noreferrer'>Connect →</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder='Your name' required />
          <input type="email" name="email" placeholder='your@email.com' required />
          <textarea name="message" rows='7' placeholder='Tell me about your project, idea or opportunity...' required></textarea>
          <button type="submit" className='btn btn-primary' disabled={status === 'sending'}>
            <FiSend />
            {status === 'idle' && 'Send message'}
            {status === 'sending' && 'Sending…'}
            {status === 'sent' && 'Sent · thank you!'}
            {status === 'error' && 'Try again'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
